module.exports = __webpack_public_path__ + "static/img/dCT3.632de4aa.png";